import type { MixedItemTag } from "@memorang/types";
import { useProethicaModuleList } from "../../hooks/useProethicaModuleList";
import type { SectionItems } from "../../types";
import { ModulesList } from "../ModulesList";

type Props = {
	items: SectionItems;
	handleShowPurchase: () => void;
	viewMode?: "list" | "grid";
};

export const ProethicaTopicsSection = ({
	items,
	handleShowPurchase,
	viewMode,
}: Props) => {
	const { getModuleListItemProps, startModule, resolveModuleItems } =
		useProethicaModuleList();

	return (
		<ModulesList
			items={resolveModuleItems(items as MixedItemTag[])}
			handleSelectTopic={startModule}
			handleShowPurchase={handleShowPurchase}
			getModuleListItemProps={getModuleListItemProps}
			viewMode={viewMode}
		/>
	);
};
